import { Component, OnInit } from '@angular/core';
import { MoveItemService } from '@scaffold/services/move-item.service';
import { NbDialogRef } from '@nebular/theme';
import { PropertiesService } from '../../services/properties.service';
import { VersionControlService } from '../../services/version-control.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ItemsService } from '@scaffold/services/items.service';
import { ViewsService } from '../../../services/views.service';
@Component({
  selector: 'app-view-modal',
  templateUrl: './view-modal.component.html',
  styleUrls: ['./view-modal.component.scss']
})
export class ViewModalComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  type: string = "";
  id: any;
  view_data: any = {};
  data: any = {};
  version;
  constructor(public dialogRef: NbDialogRef<ViewModalComponent>,
    public itemsService: ItemsService,
    private viewService: ViewsService,
    public movingItem: MoveItemService,
    private properties: PropertiesService,
    private versioning: VersionControlService) { }
  view: any;
  ngOnInit() {
    this.getViews();
    this.versioning.watchVersion().pipe(takeUntil(this.destroy$)).subscribe(v => {
      console.trace("Set Version", v)
      this.version = v;
      this.getViews();
    });
    this.dialogRef.onClose.subscribe(e => {
          this.properties.setProperties(null);      
  
    })
  }

  get size(){
    return this.data?.size||'wide'
  }

  getViews() {
    console.log(this.data);
    let url;
    if (this.data && this.data.item && this.data.item.id) {
      url = '/' + this.data.item.type + '/' + this.data.item.id + "?mode=" + this.data.mode;
    } else {
      url = '/courses/' + this.data.mode + '?mode=read';
    }
    if (this.version) {
      url += "&version=" + this.version;
    }
    this.viewService.getViews(url).subscribe(view => {
      if (view.push)
        view = view[0]
      this.view = view
    });
    
  }

  logEdits() {
        console.log(this.view_data);
  }

  checkKeys(obj): boolean {

    if (Object.keys(obj).length > 0) {
      return true;
    } else {
      return false;
    } 
  }

  save() {

    if (this.view_data) {
      this.itemsService
        .saveViewData(
          /*'/' + this.data.parent.type + '/' + this.data.parent.id +*/ "/" +
            this.data.item.type +
            "/" +
            this.data.item.id,
          { data: this.view_data }
        )
        .subscribe((d) => {
          this.dialogRef.close(d);
        });
    }
  }

  closeDialog(item) {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if (item) {
      this.dialogRef.close(item);
    } else {
      this.dialogRef.close(null);
    }
  }



}
